import { Component, OnInit } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { AllUserService } from '@api/all-user.service';
import jalaliMoment = require('jalali-moment');
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-all-users',
  templateUrl: './all-users.component.html',
  styleUrls: ['./all-users.component.scss']
})
export class AllUsersComponent implements OnInit {
  public destroy$ = new Subject<void>();
  startPage = 1;
  pageSize = 100;
  totalPage = 0;
  allUsers
  constructor(
    private allUserService: AllUserService
  ) { }

  ngOnInit(): void {
    this.getAllUsers();
  }
  getAllUsers() {
    this.allUserService.getAllUsers(this.startPage, this.pageSize).pipe(takeUntil(this.destroy$)).subscribe(
      (res: any) => {
        this.allUsers = res;
        this.allUsers.res_usrs.forEach((element): any => {
          element.registrationDate = jalaliMoment(element.registrationDate).format('jYYYY/jMM/jDD hh:mm');
        });
     
      }
    )
  }

  public getServerData(event?:PageEvent){
    this.pageSize = event.pageSize
    this.allUserService.getAllUsers( (event.pageIndex) +1 , this.pageSize).pipe(takeUntil(this.destroy$ )).subscribe(
      (res) =>{
        this.allUsers = res;

  }
    )}
}
